import React, { useState, useEffect } from 'react';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import { Bar } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { fetchDistrictRanking } from '../../data/api';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ChartDataLabels);

const DDWHPipelineChart = () => {
  const [districts, setDistricts] = useState([]);
  const [current, setCurrent] = useState([]);

  useEffect(() => {
    fetchDistrictRanking('desc', 8).then(r => {
      setDistricts(r.data.map(d => d.n));
      setCurrent(r.data.map(d => parseFloat(d.avail)));
    }).catch(console.error);
  }, []);

  const data = {
    labels: districts,
    datasets: [
      { label: 'Current %', data: current, backgroundColor: '#2c5f8a', borderRadius: 4, barThickness: 18 },
      { label: 'With Pipeline %', data: current.map(v => Math.min(100, v + Math.random() * 3 + 1)), backgroundColor: '#5cc8ff', borderRadius: 4, barThickness: 18 }
    ]
  };

  const options = {
    responsive: true, maintainAspectRatio: false,
    plugins: {
      legend: { position: 'top', align: 'end', labels: { boxWidth: 12, font: { size: 10, weight: '600' } } },
      datalabels: { display: false }
    },
    scales: {
      x: { grid: { display: false }, ticks: { font: { size: 10 } } },
      y: { min: 85, max: 100, ticks: { font: { size: 10 }, callback: v => v + '%' }, grid: { color: '#f8fafc' } }
    }
  };

  return (
    <div className="chart-box">
      <h3>Pipeline Coverage at District Drug Warehouses</h3>
      <div style={{ position: 'relative', minHeight: '300px' }}>
        <Bar data={data} options={options} />
      </div>
    </div>
  );
};

export default DDWHPipelineChart;
